import React, { useState, useEffect, useMemo, useContext } from 'react'
import { Drawer, Tabs, List, Button, message, Input, Select, Row, Col, Progress } from 'antd'
import { useTranslation } from 'react-i18next'
import { formatMoney } from 'accounting-js'
import { getStores } from '../../../../resource-management/resource-management.services'
import Icons from '@commonComponents/Icons'
import ProductCard from './product-card.component'
import { ItemCounter, CheckAll, ShoppingCart, AgentHeadphones, User } from '@mercadoni/gungnir'
import {
  getItems,
  removeItem,
  updateItem,
  sendRejectProducts,
  getItemChanges,
  getItemByJob,
  sendUndoRejection
} from '../../../flag-management.services'
import PrintProductList from './print-product-list-component'
import { useHistory, useLocation } from 'react-router-dom'
import { addItemsUseCase } from '../../../../../refactory/modules/jobs/application/post-add-items.use-case'
import { addItemsRepository } from '../../../../../refactory/modules/jobs/infrastructure/odin-nebula-add-items.repository'
import { Can } from '../../../../../refactory/modules/access-control/infrastructure/roles-permissions/access-control'
import { SubModulePerms } from '../../../../../refactory/modules/access-control/domain/module'
import { useGate } from 'statsig-react'
import ButtonOpenMultistop from '../../../../../refactory/modules/jobs/infrastructure/multistop/components/button-open-multistop'
import { OperationModels } from '../../../../../refactory/kernel/base-entities'
import { StepState, TaskNames, TaskState } from '../../../../../refactory/modules/jobs/domain/task'
import { HistoricalContext } from '../../../../../refactory/modules/jobs/infrastructure/job-detail/historical.context'

const { TabPane } = Tabs
const { Search } = Input
const { Option } = Select

const deepCopy = (objectToCopy) => {
  return JSON.parse(JSON.stringify(objectToCopy))
}

const ADDED = 'ADDED'
const PENDING = 'PENDING'
const REMOVED = 'REMOVED'
const CANCELLED = 'CANCELLED'
const REJECTED = 'REJECTED'
const BY_CLIENT = 'REJECTED_BY_USER'
const BY_DRIVER = 'REJECTED_BY_DRIVER'
const TRANSFERRING_FROM = 'TRANSFERRING_FROM'
const TRANSFERRING_FROM_STORAGE_TO_DELIVERY = 'TRANSFERRING_FROM_STORAGE_TO_DELIVERY'
const DELIVERING = 'DELIVERING'
const DOING = 'DOING'
const PICKING = 'PICKING'
const AUDITING = 'AUDITING'
const DONE = 'DONE'
const REJECT_BY_DRIVER = [TRANSFERRING_FROM, TRANSFERRING_FROM_STORAGE_TO_DELIVERY]
const CONTROL_TOWER = 'CONTROL_TOWER'
const CLIENT = 'CLIENT'
const BIFROST = 'BIFROST'
const JOB_CREATED = 'CREATED'
const JOB_PROCESSING = 'PROCESSING'
const ORIGINAL_QUANTITY_CHANGED_BY_PICKER = 'ORIGINAL_QUANTITY_CHANGED_BY_PICKER'

const CHANGE_TYPES = {
  [CANCELLED]: 'removedByPicker',
  [REMOVED]: 'removedByPicker',
  REMOVED_BY_AGENT: 'removedByAgent',
  [BY_CLIENT]: 'rejectedByClient',
  USER_REJECTION: 'rejectedByClient',
  [BY_DRIVER]: 'rejectedByDriver',
  DRIVER_REJECTION: 'rejectedByDriver',
  [ADDED]: 'addedByPicker',
  ADDED_BY_AGENT: 'addedByAgent',
  ADDED_BY_CLIENT: 'addedByClient',
  REPLACED_BY_PICKER: 'replacedByPicker',
  [PENDING]: 'pendingByPicker',
  USER_UNDO_REJECTION: 'returnedToAddedByClient',
  DRIVER_UNDO_REJECTION: 'returnedToAddedByDriver',
  ORIGINAL_QUANTITY_CHANGED_BY_PICKER: 'addedByPicker'
}

const getTaskByStepName = (tasks, stepName) => {
  return tasks.filter((task) => {
    return task.steps.filter((step) => step.type.name === stepName)[0]
  })[0]
}

const getCurrentStatus = (job) => {
  const { tasks } = job
  const deliveryTask = getTaskByStepName(tasks, DELIVERING)
  if (deliveryTask) {
    const { steps } = deliveryTask
    const isRejectByClient = steps.filter(({ type, status }) => type.name === DELIVERING && status === DOING)[0]
    const isRejectByDriver = steps.filter(
      ({ type, status }) => REJECT_BY_DRIVER.includes(type.name) && status === DOING
    )[0]
    if (isRejectByClient) {
      return 'client'
    }
    if (isRejectByDriver) {
      return 'driver'
    }
  }
  return null
}

const Items = (props) => {
  const {
    currency,
    jobTasks,
    job: { storeId, operationModel },
    currentUser: { clientLogoURL },
    jobsSearch,
    symbolValue
  } = props

  const { t } = useTranslation()
  const [showProducts, setShowProducts] = useState(false)
  const [showPrint, setShowPrint] = useState(false)
  const [showConfirm, setShowConfirm] = useState({})
  const [searchItems, setSearchItems] = useState([])
  const [localJob, setLocalJob] = useState()
  const [localItems, setLocalItems] = useState([])
  const [jobItems, setJobItems] = useState([])
  const [jobHaveZonePicking, setJobHaveZonePicking] = useState(false)
  const [optionsSelect, setOptionsSelect] = useState([])
  const [itemsByZonePicking, setItemsByZonePicking] = useState([])
  const [zonePickingSelected, setZonePickingSelected] = useState(null)
  const [itemsStats, setItemsStats] = useState({})
  const [rejectedBy, setRejectedBy] = useState(null)
  const [addBtnLoading, setAddBtnLoading] = useState({})
  const [showStoreSelect, setShowStoreSelect] = useState(false)
  const [disabledButtonAddItem, setDisabledButtonAddItem] = useState(null)
  const [stores, setStores] = useState([])
  const [filteredStores, setFilteredStores] = useState([])
  const [itemsActiveTab, setItemsActiveTab] = useState('0')
  const [unsavedComment, setUnsavedComment] = useState({})
  const [counterStates, setCounterStates] = useState([])
  const [counterTitle, setCounterTitle] = useState('')
  const [counterChanges, setCounterChanges] = useState([])
  const [selectedStore, setSelectedStore] = useState(storeId)
  const location = useLocation()
  const history = useHistory()
  const { getJobHistorical } = useContext(HistoricalContext)
  const addItemsUseCaseInteractor = addItemsUseCase(addItemsRepository)
  const isNewRejectItemsPostDeliveryActive = useGate('is_new_reject_items_active').value
  const isMultistopActive = useGate('is_multistop_active').value
  const isSupportedOperationalModelForMultiStop = useMemo(
    () => operationModel === OperationModels.PICK_AND_DELIVERY,
    [operationModel]
  )

  const itemCounterProperties = {
    changesText: t('change-history'),
    infoTooltipText: t('itemChangesInfoTooltip'),
    noChangesText: t('itemChangesInfoNoChangesText'),
    historyTitle: t('itemChangesHistoryTitle'),
    addedText: t('added'),
    removedText: t('removed'),
    rejectedText: t('rejected'),
    pendingText: t('pending'),
    userText: {
      CLIENT: t('client'),
      PICKER: t('picker'),
      AGENT: t('agent'),
      DRIVER: t('driver')
    }
  }

  useEffect(() => {
    if (zonePickingSelected !== null) {
      getItemsByZonePicking()
    }
  }, [zonePickingSelected])

  useEffect(() => {
    renderOptionsSelectZonePicking()
  }, [localItems])

  useEffect(() => {
    getJobItems()
  }, [currency])

  useEffect(() => {
    if (!props.visible) {
      setZonePickingSelected(null)
    }
  }, [props.visible])

  const getJobItems = async () => {
    const { job } = props
    const items = await getItemByJob(job.id)

    const addPathAtEndRegex = /\/orders\/[\w-]+\/items\/add$/
    const printPathAtEndRegex = /\/orders\/[\w-]+\/items\/print$/

    if (addPathAtEndRegex.test(location.pathname)) {
      setShowProducts(true)
    } else if (printPathAtEndRegex.test(location.pathname)) {
      setShowPrint(true)
    }

    setLocalJob(job)
    setJobItems(items)
    setRejectedBy(getCurrentStatus(job))
    if (job) {
      setSelectedStore(job.storeId)
    }
    refreshLocalItems(items, job)
  }

  const refreshLocalItems = (items, job) => {
    const newItems = []
    items.forEach((item) => {
      const { quantity, rejected, state } = item
      const { rejectedByDriver = 0, rejectedByUser = 0 } = rejected || {}
      if ((rejectedByDriver || rejectedByUser) && rejectedByDriver + rejectedByUser < quantity && state !== REJECTED) {
        newItems.push({
          ...item,
          state: 'REJECTED'
        })
      }
    })
    const _localItems = [...items, ...newItems]
    setZonePickingSelected(null)
    setLocalItems(_localItems)
    refreshItemsStats(_localItems)
    updateItemCounterStates(items, job)
  }

  const getItemsByZonePicking = () => {
    let temporalItemsByZonePicking = []

    const taskConsolidationFound = props.job.tasks.find((task) => task.name === 'CONSOLIDATION')

    if (taskConsolidationFound) {
      const { steps } = taskConsolidationFound
      const getCurrentState = steps.find((step) => step.type.name.includes(AUDITING))
      setDisabledButtonAddItem(getCurrentState && getCurrentState.status !== DONE ? false : true)
    }

    localItems.forEach((localItem) => {
      if (localItem.taskId === zonePickingSelected) {
        temporalItemsByZonePicking.push(localItem)
      }
    })

    refreshItemsStats(temporalItemsByZonePicking.length > 0 ? temporalItemsByZonePicking : localItems)
    setItemsByZonePicking([...temporalItemsByZonePicking])
  }

  const refreshItemsStats = (items) => {
    const customItemsStats = {
      [PENDING]: getProductsByStatus(items, [PENDING]).length,
      [ADDED]: getProductsByStatus(items, [ADDED]).length,
      [REMOVED]: getProductsByStatus(items, [REMOVED, CANCELLED]).length,
      [REJECTED]: getProductsByStatus(items, [BY_CLIENT, BY_DRIVER, REJECTED]).length
    }

    setItemsStats(customItemsStats)

    Object.keys(customItemsStats).some((key, idx) => {
      if (customItemsStats[key]) {
        setItemsActiveTab(`${idx}`)
        return true
      }

      return false
    })
  }

  const getProductsByStatus = (products, status) => {
    return products.filter((product) => status.includes(product.state))
  }

  const addItemCounterState = (items, states, filter, stateName) => {
    let quantity = getProductsByStatus(items, filter).length
    if (quantity) {
      states.push({
        name: t(`jobs.job.info.items-view.${stateName.toLowerCase()}`),
        quantity,
        state: stateName
      })
    }
  }

  const getProductFromChange = (change, itemRejected, status) => {
    const { presentation, photoUrl, name, foundQuantity } = change
    const { rejectedQuantity } = itemRejected || {}
    const price = `${t('jobs.job.info.items-view.product-card.price')}: ${formatMoney(presentation.price, symbolValue)}`
    const rejectedPum = `${rejectedQuantity ? `${rejectedQuantity} ${presentation.unit} ${t('of')}` : ''}`
    const differentQuantity =
      status === 'CHANGED_ORIGINAL_QUANTITY' ? `${foundQuantity} ${presentation.unit} ${t('of')}` : ''
    const pum = `${rejectedPum || differentQuantity} ${presentation.quantity} ${presentation.unit} | ${price}`

    return {
      image: photoUrl,
      name,
      pum
    }
  }

  const updateItemCounterStates = async (items, job) => {
    const states = []
    addItemCounterState(items, states, [PENDING], PENDING)
    addItemCounterState(items, states, [ADDED], ADDED)
    addItemCounterState(items, states, [REMOVED, CANCELLED], REMOVED)
    addItemCounterState(items, states, [BY_CLIENT, BY_DRIVER], 'REJECTED')
    setCounterStates(states)

    if (states.length === 1 && states[0].state === PENDING) {
      setCounterTitle(t('itemChangesNotStarted'))
    } else if (states.find((st) => st.state === PENDING)) {
      setCounterTitle(t('itemChangesInProcess'))
    } else {
      setCounterTitle(
        <>
          {t('itemChangesFinished')}
          <CheckAll className='changes-finished' />
        </>
      )
    }

    if (props.visible && job) {
      let itemChanges = await getItemChanges(job.id)
      let historyChanges = []
      itemChanges.forEach((change) => {
        let changes = change.history
          .filter((history) => !history.replacedBy)
          .map((lastHistory) => {
            const { timestamp, isSubstitute, isSubstituteOf, itemRejected, status } = lastHistory
            const { type: changeType, text: changeText } = getChangeType(lastHistory)

            const replacedProducts = []
            if (isSubstitute && isSubstituteOf && status !== REMOVED) {
              let substituted = itemChanges.find((it) => it.itemId === isSubstituteOf)

              if (substituted) {
                replacedProducts.push({
                  product: getProductFromChange(substituted)
                })
              }
            }

            return {
              changedBy: t(changeText),
              date: new Date(timestamp),
              products: [
                ...replacedProducts,
                {
                  product: getProductFromChange(change, itemRejected, status)
                }
              ],
              type: changeType
            }
          })

        let currentChange = changes.find(({ type }) => type === CHANGE_TYPES.REPLACED_BY_PICKER)
        if (currentChange && currentChange.type === CHANGE_TYPES.REPLACED_BY_PICKER) {
          changes = changes.filter(({ type }) => type !== CHANGE_TYPES.REPLACED_BY_PICKER)
          changes = [currentChange, ...changes]
        }

        historyChanges = [...changes, ...historyChanges]
      })
      removeProductOfHistoryChanges(historyChanges)
      setCounterChanges(historyChanges)
    }
  }

  const removeProductOfHistoryChanges = (historyChanges) => {
    historyChanges.forEach((change) => {
      if (change.type === 'removedByPicker') {
        const removedProducts = change.products.map((productObj) => productObj.product)

        historyChanges
          .filter((addedChange) => addedChange.type === 'addedByPicker')
          .forEach((addedChange) => {
            addedChange.products = addedChange.products.filter((addedProductObj) => {
              return !removedProducts.some((removedProduct) => {
                return (
                  removedProduct.image === addedProductObj.product.image &&
                  removedProduct.name === addedProductObj.product.name &&
                  removedProduct.pum === addedProductObj.product.pum
                )
              })
            })
          })

        historyChanges
          .filter((pendingChange) => pendingChange.type === 'pendingByPicker')
          .forEach((pendingChange) => {
            pendingChange.products = pendingChange.products.filter((pendingProductObj) => {
              return !removedProducts.some((removedProduct) => {
                return (
                  removedProduct.image === pendingProductObj.product.image &&
                  removedProduct.name === pendingProductObj.product.name &&
                  removedProduct.pum === pendingProductObj.product.pum
                )
              })
            })
          })
      }
    })
  }

  const removeProduct = (product) => {
    removeItem(props.jobUuid, product.itemId).then(async (result) => {
      if (result) {
        message.success(t('jobs.job.info.items-view.success'))
        handleShowConfirm(product.itemId)
        const updatedItems = updateLocalItems(product.itemId, REMOVED)
        await updateItemCounterStates(updatedItems, props.job)
      }
    })
  }

  const updateLocalItems = (itemId, state) => {
    let tempLocalItems = deepCopy(localItems)
    for (const key in tempLocalItems) {
      if (tempLocalItems[key].itemId === itemId) {
        tempLocalItems[key].state = state
      }
    }
    setLocalItems(tempLocalItems)
    return tempLocalItems
  }

  const searchItem = (itemName) => {
    const { job } = props

    let storeReference = null
    if (selectedStore && showStoreSelect) {
      const store = stores.find((st) => st.id === selectedStore)
      storeReference = store.clientReference
    }

    getItems(itemName, storeReference, job.source, job.reference).then(({ products }) => {
      if (products) {
        setSearchItems([])
        setSearchItems(products)
      }
    })
  }

  const handleShowProducts = () => {
    if (!showProducts) {
      history.push(`${location.pathname}/add`)
    } else {
      history.push(location.pathname.split('/add')[0])
    }
    if (showProducts) {
      setShowStoreSelect(false)
    }
    setShowProducts(!showProducts)
  }

  const showSelectStores = () => {
    getStoreOptions()
  }

  const handleShowPrint = () => {
    if (!showPrint) {
      history.push(`${location.pathname}/print`)
    } else {
      history.push(location.pathname.split('/print')[0])
    }
    setShowPrint(!showPrint)
  }

  const handleShowConfirm = (id) => {
    setShowConfirm({
      ...showConfirm,
      ...{
        [id]: showConfirm[id] ? !showConfirm[id] : true
      }
    })
  }

  /**
   * Run when to add a product.
   *
   * @param {*} quantity Quantity.
   * @param {*} item     Product.
   */
  const addProduct = async (quantity, item, comment) => {
    if (quantity <= 0) return

    const { presentation } = item

    let itemToAdd = {
      ...item,
      comment,
      quantity: quantity || 1,
      unit: presentation.unit,
      sub_unit: presentation.sub_unit,
      sub_quantity: presentation.sub_quantity || 0,
      weight: presentation.weight,
      volume: presentation.volume,
      price: presentation.price.amount
    }

    delete itemToAdd.presentation
    delete itemToAdd.presentationV2
    delete itemToAdd.photoUrl

    const requestBody = {
      jobId: props.jobUuid,
      origin: CONTROL_TOWER,
      currency,
      items: itemToAdd
    }
    const result = await addItemsUseCaseInteractor(requestBody)
    if (result) {
      message.success(t('jobs.job.info.items-view.add-items-view.success'))
      setAddBtnLoading({ [item.id]: false })
    } else {
      setAddBtnLoading({ [item.id]: false })
    }
  }

  const updateProduct = async (newQuantity, item) => {
    try {
      const { itemId, comment } = item
      const result = await updateItem(props.jobUuid, itemId, {
        comment,
        quantity: newQuantity
      })
      if (result) {
        message.success(t('jobs.job.info.items-view.update-items-view.success'))
        if (jobsSearch) {
          getJobHistorical(props?.job?.id)
        }
      }
    } catch (error) {
      message.error(t('jobs.job.info.items-view.update-items-view.error'))
    }
  }

  const sendComment = async (comment, item) => {
    const { itemId, quantity, presentationV2 } = item
    const productQuantity = presentationV2 ? presentationV2.quantity : quantity || 1
    await updateProduct(productQuantity, { itemId, comment })
    setUnsavedComment({ ...unsavedComment, [itemId]: comment })
  }

  const getAddedBy = (origin) => {
    const addedByOdin = {
      icon: <AgentHeadphones />,
      text: t('jobs.job.info.items-view.product-card.agent-label')
    }

    const options = {
      CLIENT: {
        icon: <User />,
        text: t('jobs.job.info.items-view.product-card.client-label')
      },
      AGENT: addedByOdin,
      ODIN: addedByOdin,
      CONTROL_TOWER: addedByOdin,
      PICKER: {
        icon: <ShoppingCart />,
        text: t('jobs.job.info.items-view.product-card.picker-label')
      }
    }
    return options[origin] || { icon: 'shopping-cart' }
  }

  const getReplacedBy = (items, replacedById) => {
    let replacedBy = items.find((i) => i.itemId === replacedById)

    if (replacedBy) {
      const { name, presentation, presentationV2, photoUrl, quantity } = replacedBy
      const price = ` ${t('jobs.job.info.items-view.product-card.price')}: ${formatMoney(
        presentationV2 ? presentationV2.price : presentation.price.amount,
        symbolValue
      )}`
      const contentUnits = presentationV2 ? ` ${quantity} ${presentationV2.unit}` : ` ${quantity} ${presentation.unit}`
      const priceLabel = presentationV2
        ? ` ${presentationV2.subQuantity} ${presentationV2.subUnit} | ${price}`
        : ` ${presentation.quantity} ${presentation.unit} | ${price}`

      replacedBy = {
        unitValueText: priceLabel,
        title: name,
        contentUnits,
        image: photoUrl
      }
    }

    return replacedBy
  }

  const getQuantity = (item) => {
    const state = item.state
    if (state === REJECTED) {
      return item.rejected.rejectedByDriver + item.rejected.rejectedByUser
    }
    if (state === PENDING) {
      return item.quantity
    }
    return item.foundQuantity
  }

  const paintListOfProducts = (state) => {
    const items = jobHaveZonePicking ? itemsByZonePicking : localItems
    const packages = localJob?.packages
    const { status: jobStatus } = localJob

    if (!jobHaveZonePicking && disabledButtonAddItem === null) {
      wasPickingDone(props.job.tasks)
    }

    const productsSections = getProductsSections({ items, packages, state })

    return (
      <React.Fragment>
        {productsSections.map(({ _package, items: packageItems }, idx) => {
          return (
            <React.Fragment key={idx}>
              {_package && packageItems && packageItems.length > 0 ? (
                <h4 className='product-package'>
                  {t('jobs.job.info.items-view.package', _package)} ·{' '}
                  {_package.zone
                    ? t('jobs.job.info.items-view.package-zone', _package)
                    : t('jobs.job.info.items-view.package-pending', _package)}
                </h4>
              ) : (
                ''
              )}
              <List itemLayout='horizontal'>
                {packageItems.map((item, index) => {
                  const disabled =
                    !state.includes('PENDING') ||
                    !Can([SubModulePerms.JOB_GENERAL_ITEMS]) ||
                    props.isCancelled ||
                    props.isDelivered()
                  const {
                    quantity,
                    presentation,
                    presentationV2,
                    photoUrl,
                    comment,
                    foundQuantity,
                    origin,
                    isSubstitute,
                    itemId,
                    state: itemState,
                    rejected,
                    attributes
                  } = item
                  const contentUnits = presentationV2
                    ? `${presentationV2.subQuantity} ${presentationV2.subUnit}`
                    : `${presentation.quantity} ${presentation.unit}`
                  const price = ` ${t('jobs.job.info.items-view.product-card.total-price')}: ${formatMoney(
                    presentationV2 ? presentationV2.price : presentation.price.amount,
                    symbolValue
                  )}`
                  const quantityText = ` ${getQuantity(item)} ${t('jobs.job.info.items-view.product-card.from')} ${
                    presentationV2 ? presentationV2.quantity : presentation.quantity
                  }`
                  const priceLabel = presentationV2
                    ? ` ${quantityText} ${presentationV2.unit} | ${price}`
                    : ` ${quantityText} ${presentation.unit} | ${price}`
                  const unitPrice = ` ${t('jobs.job.info.items-view.product-card.price')}: ${formatMoney(
                    presentationV2 ? presentationV2.price : presentation.price.amount,
                    symbolValue
                  )}`
                  const unitValueText = presentationV2
                    ? ` ${presentationV2.subQuantity} ${presentationV2.subUnit} | ${unitPrice}`
                    : ` ${presentation.quantity} ${presentation.unit} | ${unitPrice}`

                  const replacedBy = getReplacedBy(items, item.replacedBy)
                  const replaceTo = isSubstitute
                    ? {
                        text: t('jobs.job.info.items-view.product-card.view-removed-items'),
                        onClick: () => {
                          setItemsActiveTab('2')
                        }
                      }
                    : null

                  let productQty = presentationV2 ? presentationV2.quantity : quantity !== undefined ? quantity : 1
                  const isReject = [BY_DRIVER, BY_CLIENT, REJECTED].includes(itemState)
                  if (itemState === ADDED) {
                    productQty = foundQuantity
                  } else if (isReject) {
                    const { rejectedByDriver = 0, rejectedByUser = 0 } = rejected || {}
                    productQty = rejectedByDriver + rejectedByUser
                  }

                  const productProps = {
                    copy: t,
                    mode: 'UPDATE',
                    productQty,
                    product: {
                      ...item,
                      attributes,
                      contentUnits,
                      pum: priceLabel,
                      image: photoUrl,
                      um: presentationV2 ? presentationV2.unit : presentation.unit,
                      instructions: unsavedComment[item.itemId] || comment,
                      addedBy: getAddedBy(origin),
                      quantity: productQty,
                      replaceTo,
                      replacedBy,
                      unitValueText
                    },
                    showRejectItem: isNewRejectItemsPostDeliveryActive ? false : !!rejectedBy && itemState === ADDED,
                    showUndo: isNewRejectItemsPostDeliveryActive ? false : !!rejectedBy && isReject,
                    allowAddComment: [JOB_CREATED, JOB_PROCESSING].includes(jobStatus),
                    updateProduct: (newQuantity) => updateProduct(newQuantity, item),
                    removeProduct: () => removeProduct(item),
                    sendComment: (itemComment) => sendComment(itemComment, item),
                    rejectProduct: (value) => sendTheRejectProducts(item, value),
                    undoRejection: () => undoRejection(item),
                    disabled,
                    copyAddedBy: t('jobs.job.info.items-view.product-card.added-by-label'),
                    copyReplaceTo: t('jobs.job.info.items-view.product-card.replace-to-label'),
                    copyReplacedBy: t('jobs.job.info.items-view.product-card.replaced-by-label'),
                    copyUnitValue: t('jobs.job.info.items-view.product-card.unit-value-label')
                  }

                  if (productProps.product.attributes.category === 'Special Product') {
                    productProps.product.image = 'https://odin-images-and-files.s3.amazonaws.com/gift.png'
                  }

                  return (
                    <List.Item className='product-card-container' key={`${itemId}-${index}`}>
                      <ProductCard {...productProps} />
                    </List.Item>
                  )
                })}
              </List>
            </React.Fragment>
          )
        })}
      </React.Fragment>
    )
  }

  const sendTheRejectProducts = async ({ itemId }, quantity) => {
    try {
      const job = await sendRejectProducts(props.jobId, [
        {
          id: itemId,
          rejected_quantity: quantity
        }
      ])

      if (job) {
        message.success(t('rejectProductsSuccess'))
        props.setSelectedJob(job)
      }
    } catch (err) {
      console.error('Error rejecting items on: ', itemId, props.jobId)
    }
  }

  const undoRejection = async ({ itemId }) => {
    try {
      const job = await sendUndoRejection(props.jobId, [itemId])

      if (job) {
        message.success(t('itemReturnedToAdded'))
        props.setSelectedJob(job)
      }
    } catch (err) {
      console.error('Error undoing the rejecting for items on:', itemId, props.jobId)
    }
  }

  const wasPickingDone = (tasks) => {
    const pickingTask = tasks.find((task) =>
      [
        TaskNames.PICKING,
        TaskNames.FULL_SERVICE,
        TaskNames.PICKING_WITH_STORAGE,
        TaskNames.PICKING_AND_STORAGE,
        TaskNames.ZONE_PICKING,
        TaskNames.ZONE_PICKING_AND_COLLECT,
        TaskNames.PICKING_MULTI_STOP
      ].includes(task.name)
    )
    if (pickingTask) {
      const { steps } = pickingTask
      if (pickingTask.name === TaskNames.PICKING_MULTI_STOP) {
        const stepsMultistopPending = tasks
          .filter(({ name, status }) => name === TaskNames.PICKING_MULTI_STOP && status !== TaskState.CANCELED)
          .flatMap((task) => task.steps)
          .filter((step) => step.type.name === TaskNames.PICKING && step.status !== StepState.DONE)

        setDisabledButtonAddItem(stepsMultistopPending?.length ? false : true)
        return
      }
      const checkingOutStep = steps.find((step) => step.type.name.includes(PICKING))
      setDisabledButtonAddItem(checkingOutStep && checkingOutStep.status !== DONE ? false : true)
    }
  }

  /**
   * Render the tab bar for store and general catalog.
   */
  const renderStoreCatalogButtons = () => {
    const buttonStyle = {
      margin: '15px 0',
      width: '100%'
    }
    return (
      <>
        <Row gutter={16}>
          {props?.featureFlags?.hideGeneralCatalog === 'false' ? (
            <Col span={12}>
              <Button
                style={buttonStyle}
                icon={
                  <span role='img' aria-label='catalog' className='anticon'>
                    <Icons iconName='Catalog' />
                  </span>
                }
                onClick={() => setShowStoreSelect(false)}
                className={'store-buttons ' + (!showStoreSelect ? 'active' : '')}
              >
                {t('jobs.job.info.items-view.add-items-view.catalog.general-button')}
              </Button>
            </Col>
          ) : null}
          <Col span={12}>
            <Button
              style={buttonStyle}
              icon={
                <span role='img' aria-label='shopping-cart' className='anticon'>
                  <Icons iconName='Shopper' />
                </span>
              }
              onClick={showSelectStores}
              className={'store-buttons ' + (showStoreSelect ? 'active' : '')}
            >
              {t('jobs.job.info.items-view.add-items-view.catalog.store-button')}
            </Button>
          </Col>
        </Row>
      </>
    )
  }

  /**
   * Get a list of stores for stores select
   */
  const getStoreOptions = () => {
    getStores({ limit: 300, offset: 0 }).then((result) => {
      const newStores = result.stores.sort((st1, st2) => {
        if (!st1 || !st1.location || !st1.location.name || !st2 || !st2.location || !st2.location.name) {
          return -1
        }
        return st1.location.name.localeCompare(st2.location.name)
      })
      setStores(newStores)
      setFilteredStores(newStores)
      setShowStoreSelect(true)
    })
  }

  /**
   * Runs when text is typed in store select.
   */
  const onSearchStore = (value) => {
    if (!value) {
      setFilteredStores(stores)
    }

    const newFilteredStores = stores.filter(({ location: { name } }) => {
      return name.toLowerCase().includes(value.toLowerCase())
    })
    setFilteredStores(newFilteredStores)
  }

  /**
   * Runs when a store is selected.
   *
   * @param {string} value Current store value.
   */
  const onChangeStore = (value) => {
    setSelectedStore(value)
  }

  const paintListOfSearchedProducts = (items) => {
    return (
      <React.Fragment>
        <List itemLayout='horizontal' dataSource={items} renderItem={(item, index) => paintItem(item, index)} />
      </React.Fragment>
    )
  }

  const paintItem = (item, index, state) => {
    const disabled = state && !state.includes('PENDING')
    const { quantity, presentation, presentationV2, comment } = item
    const contentUnits = presentationV2
      ? `${presentationV2.subQuantity} ${presentationV2.subUnit}`
      : `${presentation.quantity} ${presentation.unit}`
    const price = ` ${t('jobs.job.info.items-view.product-card.price')}: ${formatMoney(
      presentationV2 ? presentationV2.price : presentation.price.amount,
      symbolValue
    )}`
    const priceLabel = presentationV2
      ? ` ${presentationV2.quantity} ${presentationV2.unit} | ${price}`
      : ` ${presentation.quantity} ${presentation.unit} | ${price}`
    const unitValueText = presentationV2
      ? ` ${presentationV2.subQuantity} ${presentationV2.subUnit} | ${price}`
      : ` ${presentation.quantity} ${presentation.unit} | ${price}`
    const photoUrl = item.photoUrl ? item.photoUrl : item.photo_url
    let productProps = {
      copy: t,
      mode: state ? 'UPDATE' : 'ADD',
      productQty: presentationV2 ? presentationV2.quantity : quantity !== undefined ? quantity : 1,
      product: {
        ...item,
        contentUnits,
        pum: priceLabel,
        image: photoUrl,
        um: presentationV2 ? presentationV2.unit : presentation.unit,
        disabled,
        unitValueText
      }
    }

    if (state) {
      productProps = Object.assign(productProps, {
        instructions: comment,
        updateProduct: (newQuantity) => updateProduct(newQuantity, item.itemId),
        removeProduct: () => removeProduct(item)
      })
    } else {
      productProps = Object.assign(productProps, {
        isLoading: addBtnLoading[item.id],
        disabledAddBtn: Can([SubModulePerms.JOB_GENERAL_ITEMS]),
        sendComment: (newQuantity, comment) => addProduct(newQuantity, item, comment)
      })
    }

    return (
      <List.Item key={index}>
        <ProductCard {...productProps} />
      </List.Item>
    )
  }

  const changeItemsStateTab = () => {
    const options = {
      0: PENDING,
      1: ADDED,
      2: REMOVED
    }

    return options[itemsActiveTab] || PENDING
  }

  const getChangeType = ({ status = ADDED, origin, isSubstitute, removedBy }) => {
    const changeText = {
      [CANCELLED]: 'itemChangesRemovedByPicker',
      [REMOVED]: 'itemChangesRemovedByPicker',
      REMOVED_BY_AGENT: 'itemChangesRemovedByAgent',
      [BY_CLIENT]: 'itemChangesRejectedByClient',
      USER_REJECTION: 'itemChangesRejectedByClient',
      [BY_DRIVER]: 'itemChangesRejectedByDriver',
      DRIVER_REJECTION: 'itemChangesRejectedByDriver',
      [ADDED]: 'itemChangesAddedByPicker',
      ADDED_BY_AGENT: 'itemChangesAddedByAgent',
      ADDED_BY_CLIENT: 'itemChangesAddedByClient',
      REPLACED_BY_PICKER: 'itemChangesReplacedByPicker',
      [PENDING]: 'itemChangesPendingByPicker',
      USER_UNDO_REJECTION: 'itemChangesUndoRejectionByClient',
      DRIVER_UNDO_REJECTION: 'itemChangesUndoRejectionByDriver',
      ORIGINAL_QUANTITY_CHANGED_BY_PICKER: 'originalQuantityChangedByPicker'
    }

    const odinOrigin = ['odin', CONTROL_TOWER.toLowerCase()]

    if ([PENDING, ADDED].includes(status)) {
      if (odinOrigin.includes(origin.toLowerCase())) {
        status = 'ADDED_BY_AGENT'
      } else if (origin === 'PICKER') {
        status = ADDED

        if (isSubstitute) {
          status = 'REPLACED_BY_PICKER'
        }
      } else if (origin.toUpperCase() === BIFROST) {
        status = 'ADDED_BY_CLIENT'
      }
    } else if (status === CANCELLED) {
      if (odinOrigin.includes(origin.toLowerCase()) || removedBy === 'agent') {
        status = 'REMOVED_BY_AGENT'
      } else if (CLIENT === origin.toUpperCase()) {
        status = BY_CLIENT
      }
    } else if (status === 'REJECTED') {
      if (origin.toUpperCase() === CLIENT) {
        status = BY_CLIENT
      }
    } else if (status === 'CHANGED_ORIGINAL_QUANTITY') {
      status = ORIGINAL_QUANTITY_CHANGED_BY_PICKER
    }

    return {
      type: CHANGE_TYPES[status],
      text: changeText[status]
    }
  }

  const handleChangeSelectZonePicking = (value) => {
    setZonePickingSelected(value)
  }

  const itemsNumberInProgress = (items) => {
    let itemsProgress = {
      totalItems: 0,
      pendingItems: 0,
      addedItems: 0,
      removedItems: 0,
      rejectedItems: 0
    }

    if (items && items.length > 0) {
      items.forEach((item) => {
        switch (item.state) {
          case 'PENDING':
            itemsProgress.pendingItems++
            break
          case 'ADDED':
            itemsProgress.addedItems++
            break
          case 'REMOVED':
          case 'CANCELLED':
            itemsProgress.removedItems++
            break
          case 'REJECTED':
            itemsProgress.rejectedItems++
            break
          default:
            break
        }
      })

      itemsProgress.totalItems = items.length
    }

    return itemsProgress
  }

  const showProgressBarOfItems = (itemsNumber, color) => {
    return (
      <Col flex={itemsNumber}>
        {itemsNumber > 0 ? (
          <div className='div-item-state'>
            <span>{itemsNumber} items</span>
          </div>
        ) : null}
        <Progress
          percent={Math.round((itemsNumber * 100) / itemsNumber)}
          size='small'
          strokeColor={color}
          showInfo={false}
        />
      </Col>
    )
  }

  const renderProgressBarItems = (items) => {
    const result = itemsNumberInProgress(items)

    return (
      <Row className='progress-bar-zone-picking'>
        {showProgressBarOfItems(result.addedItems, '#29A829')}
        {showProgressBarOfItems(result.removedItems, '#f9d350')}
        {showProgressBarOfItems(result.rejectedItems, '#ff4d4f')}
        {showProgressBarOfItems(result.pendingItems, '#b2b6ba')}
      </Row>
    )
  }

  const renderOptionsSelectZonePicking = () => {
    let options = []
    let flagZonePickingSelected = true
    setJobHaveZonePicking(false)
    setDisabledButtonAddItem(null)

    if (jobTasks.length > 0) {
      jobTasks.forEach((job) => {
        if (job.name === 'ZONE_PICKING') {
          let stringDepartments = ''

          if (job.departments && job.departments.length > 0) {
            job.departments.forEach((department) => {
              stringDepartments += `${department} | `
            })
          }

          setJobHaveZonePicking(true)
          const zonePickingFound = localItems.find((item) => item.taskId === job.uuid) ? true : false

          options.push(
            <Option key={job.uuid} disabled={!zonePickingFound}>
              <Row>
                <Col span='23'>
                  <span>
                    {t(`jobs.tasks.name.ZONE`)} - {stringDepartments}
                  </span>
                </Col>
                {!zonePickingFound ? (
                  <Col span='1'>
                    <span>
                      <Icons iconName='CheckCircleGreen' />
                    </span>
                  </Col>
                ) : null}
              </Row>
            </Option>
          )

          if (!zonePickingSelected && zonePickingFound && flagZonePickingSelected) {
            flagZonePickingSelected = !flagZonePickingSelected
            handleChangeSelectZonePicking(job.uuid)
          }
        } else if (job.name === 'CONSOLIDATION') {
          const consolidationFound = localItems.find((item) => item.taskId === job.uuid) ? true : false

          if (consolidationFound) {
            options.push(<Option key={job.uuid}>{t(`jobs.tasks.name.${job.name}`)}</Option>)
          }

          if (!zonePickingSelected && consolidationFound && flagZonePickingSelected) {
            flagZonePickingSelected = !flagZonePickingSelected
            handleChangeSelectZonePicking(job.uuid)
          }
        }
      })
    }

    setOptionsSelect(options)
  }

  return (
    <Drawer
      className='items-drawer'
      title={t('jobs.job.info.items-view.title')}
      width={670}
      onClose={props.handleItems}
      visible={props.visible}
    >
      <ItemCounter {...itemCounterProperties} states={counterStates} title={counterTitle} changes={counterChanges} />

      <Row className='row-action-item-list' style={{ display: 'flex', gap: '5px' }}>
        <Col style={{ flex: '2' }}>
          <Button
            id='job-info-print-products-pdf'
            onClick={handleShowPrint}
            type='default'
            className='button-print-item-list'
          >
            {t('jobs.job.info.items-view.print.title')}
          </Button>
        </Col>
        {Can([SubModulePerms.JOB_GENERAL_ITEMS]) && (
          <Col style={{ flex: '2' }}>
            <Button
              id='search-items'
              onClick={handleShowProducts}
              type='primary'
              className='add-item-to-list'
              disabled={disabledButtonAddItem}
            >
              {t('jobs.job.info.items-view.add-item')}
            </Button>
          </Col>
        )}
        {isMultistopActive && Can([SubModulePerms.JOB_GENERAL_MULTISTOP]) && isSupportedOperationalModelForMultiStop && (
          <Col style={{ flex: '1', maxWidth: '30px' }}>
            <ButtonOpenMultistop job={props.job} setSelectedJob={props.setSelectedJob} />
          </Col>
        )}
      </Row>
      {jobHaveZonePicking ? (
        <Row className='row-action-item-list'>
          <Col span={24}>
            <h4>{t('selectZonePickingToReview')}</h4>
            <Select
              size='default'
              value={zonePickingSelected}
              onChange={handleChangeSelectZonePicking}
              style={{ width: '100%' }}
            >
              {optionsSelect}
            </Select>

            {renderProgressBarItems(itemsByZonePicking)}
          </Col>
        </Row>
      ) : null}
      <Tabs activeKey={itemsActiveTab} onTabClick={(key) => setItemsActiveTab(key)}>
        {itemsStats[PENDING] ? (
          <TabPane tab={t('jobs.job.info.items-view.pending')} key='0'>
            {paintListOfProducts([PENDING])}
          </TabPane>
        ) : null}

        {itemsStats[ADDED] ? (
          <TabPane tab={t('jobs.job.info.items-view.added')} key='1'>
            {paintListOfProducts([ADDED])}
          </TabPane>
        ) : null}

        {itemsStats[REMOVED] ? (
          <TabPane tab={t('jobs.job.info.items-view.removed')} key='2'>
            {paintListOfProducts([REMOVED, CANCELLED])}
          </TabPane>
        ) : null}

        {itemsStats[REJECTED] ? (
          <TabPane tab={t('jobs.job.info.items-view.rejected')} key='3'>
            {paintListOfProducts([BY_CLIENT, BY_DRIVER, REJECTED])}
          </TabPane>
        ) : null}
      </Tabs>

      {showPrint && (
        <PrintProductList
          job={{ ...localJob, items: jobItems }}
          items={localItems}
          visible={showPrint}
          width={'50%'}
          onClose={handleShowPrint}
          state={changeItemsStateTab()}
          title={t('jobs.job.info.items-view.print.title')}
          currency={currency}
          clientLogoURL={clientLogoURL}
          symbolValue={symbolValue}
        />
      )}
      <Drawer
        className='products-drawer'
        title={t('jobs.job.info.items-view.add-items-view.title')}
        width={600}
        onClose={handleShowProducts}
        visible={showProducts}
      >
        <Search
          placeholder={t('jobs.job.info.items-view.add-items-view.search')}
          onSearch={searchItem}
          style={{ width: '100%' }}
        />
        {props?.featureFlags?.hasStoreCatalog === 'true' ? (
          <>
            {renderStoreCatalogButtons()}
            {showStoreSelect ? (
              <Select
                showSearch
                style={{ width: '100%' }}
                placeholder={t('jobs.job.info.items-view.add-items-view.catalog.select-store')}
                onSearch={onSearchStore}
                filterOption={false}
                className='store-select'
                defaultValue={storeId}
                onChange={onChangeStore}
              >
                {filteredStores.map(({ id, location: { name } }, idx) => (
                  <Option key={idx} value={id}>
                    <span className='store-select-option'>{name}</span>
                  </Option>
                ))}
              </Select>
            ) : null}
          </>
        ) : null}
        {paintListOfSearchedProducts(searchItems)}
      </Drawer>
    </Drawer>
  )
}

export default Items

function getProductsSections({ items, packages, state }) {
  const sections = []
  const itemsInState = items?.filter((item) => state.includes(item?.state)) || []
  const packagesInState =
    packages?.filter((_package) =>
      itemsInState.some(
        (item) =>
          (!!item?.packageId && item.packageId === _package?.id) ||
          (!!item?.packageReference && item.packageReference === _package?.reference)
      )
    ) || []
  const itemsIdsInsidePackages = []

  for (const _package of packagesInState) {
    const itemsInsidePackage = itemsInState?.filter(
      (item) =>
        (!!item?.packageReference && item.packageReference === _package?.reference) ||
        (!!item?.packageId && item.packageId === _package?.id)
    )

    sections.push({
      _package,
      items: itemsInsidePackage
    })

    itemsIdsInsidePackages.push(...itemsInsidePackage.map((item) => item.id))
  }

  const itemsWithoutPackages = itemsInState.filter((item) => !itemsIdsInsidePackages.includes(item.id))

  if (itemsWithoutPackages.length > 0) {
    sections.unshift({ _package: null, items: itemsWithoutPackages })
  }

  return sections
}
